import {useI18n, useFormatNumber} from '@udemy-v2/i18n';
import {Icon} from '@udemy-v2/icons';
import classNames from 'classnames';
import React from 'react';

import styles from './review-title.module.scss';
import {ReviewsContext} from './types';

interface ReviewTitleProps {
    reviewsContext?: ReviewsContext;
    isXsMax: boolean;
    className?: string;
}
export const ReviewTitle = ({reviewsContext, isXsMax, className}: ReviewTitleProps) => {
    const {interpolate, ninterpolate, gettext} = useI18n();
    const {formatNumber} = useFormatNumber();

    if (!reviewsContext) {
        return null;
    }

    const totalDistributionCount = reviewsContext.ratingDistribution.reduce(
        (acc: number, dist: {count: number}) => acc + dist.count,
        0,
    );
    const courseRatingNumber = formatNumber(reviewsContext.averageRating, {
        maximumFractionDigits: 1,
    });
    const courseRating = isXsMax
        ? courseRatingNumber
        : interpolate(gettext('%(rating)s course rating'), {rating: courseRatingNumber}, true);
    const ratings = ninterpolate(
        '%(rating)s rating',
        '%(rating)s ratings',
        totalDistributionCount,
        {
            rating: formatNumber(totalDistributionCount, {
                notation: 'compact',
            }),
        },
    );

    return (
        <div className={classNames(styles['review-title'], className)}>
            <Icon glyph="rating-star" color="warning" size="medium" label={false} />
            <span className={'ud-heading-xl'}>{courseRating}</span>
            <Icon glyph="bullet" color="subdued" size="xsmall" label={false} />
            <span className={'ud-heading-xl'}>{ratings}</span>
        </div>
    );
};
